export enum AdFetchingStatus {
  OK = 'OK',
  EMPTY_VAST = 'EMPTY_VAST',
  NO_NABOO_ADS = 'NO_NABOO_ADS',
  BAD_INSERTION_METHOD = 'BAD_INSERTION_METHOD',
}
